<template>
  <div class="cloud-Gas">
    <div class="cloud-Gas-l">
      <div class="cloud-Gas-title" style="width: 100%; height: 17.5vh">
        <div class="cloud-Gas-title-title">
          <img
            src="@/assets/images/groupTitlec.png"
            alt=""
            style="height: 4vh"
          />
          <p>当天在洞设备情况</p>
          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '5%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 94%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
        <div
          class="cloud-Gas-title-content"
          style="width: 100%; height: 13vh; overflow: hidden"
        >
          <ul class="cloud-Gas-title-content-ul">
            <li>
              <div>
                <span style="font-size: 2vh">{{ gasDeviceData[0].value }}</span
                >台
              </div>
              <div>
                <img
                  src="@/assets/images/monitoring.png"
                  alt=""
                  style="height: 4vh"
                />
                传感器总数
              </div>
            </li>
            <li>
              <div>
                <span style="font-size: 2vh">{{ gasDeviceData[1].value }}</span
                >台
              </div>
              <div>
                <img
                  src="@/assets/images/networking.png"
                  alt=""
                  style="height: 4vh"
                />
                设备在线
              </div>
            </li>
            <li>
              <div>
                <span style="font-size: 2vh">{{ gasDeviceData[2].value }}</span
                >台
              </div>
              <div>
                <img
                  src="@/assets/images/deviceOffline.png"
                  alt=""
                  style="height: 4vh"
                />
                设备离线
              </div>
            </li>
            <li>
              <div>
                <span style="font-size: 2vh">{{ gasDeviceData[3].value }}</span
                >台
              </div>
              <div>
                <img
                  src="@/assets/images/deviceOnline.png"
                  alt=""
                  style="height: 4vh"
                />
                设备在线率
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="cloud-Gas-title"
        style="width: 100%; height: 32.5vh; margin-top: 1vh"
      >
        <div class="cloud-Gas-title-title">
          <img
            src="@/assets/images/groupTitlec.png"
            alt=""
            style="height: 4vh"
          />
          <p style="width: 12vw; float: left">当日气体检测查询</p>
          <ul
            v-if="
              TunnelsData.itemTunnelType === '4' ||
              TunnelsData.itemTunnelType === '5'
            "
            class="cloud-detail-title-btn"
          >
            <li
              :class="{ active: itemTunnelTypeNUm === '2' }"
              @click="handleTunnelClick(-1, '2')"
            >
              左洞
            </li>
            <li
              :class="{ active: itemTunnelTypeNUm === '1' }"
              @click="handleTunnelClick(1, '1')"
            >
              右洞
            </li>
          </ul>
          <ul
            v-if="TunnelsData.itemTunnelType === '3'"
            class="cloud-detail-title-btn"
          >
            <li
              :class="{ active: itemTunnelTypeNUm === '5' }"
              @click="handleTunnelClick(0, '5')"
            >
              斜井
            </li>
            <li
              :class="{ active: itemTunnelTypeNUm === '4' }"
              @click="handleTunnelClick(1, '4')"
            >
              左洞
            </li>
            <li
              :class="{ active: itemTunnelTypeNUm === '3' }"
              @click="handleTunnelClick(2, '3')"
            >
              右洞
            </li>
          </ul>
          <ul
            v-if="TunnelsData.itemTunnelType === '7'"
            class="cloud-detail-title-btn"
          >
            <li
              :class="{ active: itemTunnelTypeNUm === '10' }"
              @click="handleTunnelClick(0, '10')"
            >
              斜井
            </li>
            <li
              :class="{ active: itemTunnelTypeNUm === '9' }"
              @click="handleTunnelClick(1, '9')"
            >
              左洞1
            </li>
            <li
              :class="{ active: itemTunnelTypeNUm === '8' }"
              @click="handleTunnelClick(2, '8')"
            >
              右洞1
            </li>
            <li
              :class="{ active: itemTunnelTypeNUm === '7' }"
              @click="handleTunnelClick(3, '7')"
            >
              左洞2
            </li>
            <li
              :class="{ active: itemTunnelTypeNUm === '6' }"
              @click="handleTunnelClick(4, '6')"
            >
              右洞2
            </li>
          </ul>
          <ul class="cloud-Gas-title-title-ul-day">
            <li
              for="i"
              v-for="(item, index) in lastSevenDays"
              :key="index"
              @click="activeIndex = index"
              :class="{ active: activeIndex === index }"
            >
              <div class="dayDiv">{{ item.date }}</div>
            </li>
          </ul>
        </div>
        <div
          class="cloud-Gas-title-content"
          style="width: 100%; height: 28vh; overflow: hidden"
        >
          <div
            id="main_gasHoury"
            style="
              width: 120%;
              height: 26vh;
              margin-top: 2vh;
              margin-left: -4vw;
              z-index: 9999;
            "
          ></div>
        </div>
      </div>

      <div
        class="cloud-Gas-title"
        style="width: 100%; height: 32.5vh; margin-top: 1vh"
      >
        <div class="cloud-Gas-title-title">
          <img
            src="@/assets/images/groupTitlec.png"
            alt=""
            style="height: 4vh"
          />
          <p>最近七天气体预警查询</p>
          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '5%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 94%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
        <div
          class="cloud-Gas-title-content"
          style="width: 100%; height: 29vh; overflow: hidden"
        >
          <div
            id="main_gasDay"
            style="
              width: 120%;
              height: 26vh;
              margin-top: 2vh;
              margin-left: -4vw;
            "
          ></div>
        </div>
      </div>
    </div>
    <div class="cloud-Gas-r">
      <div class="cloud-Gas-title" style="width: 100%; height: 84.5vh">
        <div
          class="cloud-Gas-title-content"
          style="width: 100%; height: 80vh; overflow: hidden"
        >
          <div
            class="cloud-Gas-title-content-table"
            style="
              background-color: #0060ff;
              height: 3.5vh;
              margin-top: -1vh;
              padding-top: 0.5vh;
            "
          >
            <p style="color: #fff">所在区域</p>
            <p style="color: #fff">气体名称</p>
            <p style="color: #fff">安装位置</p>
            <p style="color: #fff">当前数值</p>
            <p style="color: #fff">报警状态</p>
            <p style="color: #fff">高低报警值</p>
            <p style="color: #fff">更新时间</p>
          </div>
          <div
            style="
              width: 100%;
              height: 68vh;
              overflow-y: auto;
              scrollbar-width: thin;
              scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
            "
          >
            <div
              class="cloud-Gas-title-content-table"
              v-for="(item, index) in gasNetworkingData"
              :key="index"
            >
              <p>{{ item.regional }}</p>
              <p>{{ item.name }}</p>
              <p>{{ item.position }}</p>
              <p>{{ item.value }} {{ item.unit }}</p>

              <p
                :style="{
                  color: item.value > item.highAlarmValue ? 'red' : '',
                }"
              >
                {{ item.value > item.highAlarmValue ? "预警" : "" }}
              </p>

              <p
                v-if="item.openHighAlarm === '1' && item.openLowAlarm === '1'"
              ></p>
              <p v-if="item.openHighAlarm === '0' && item.openLowAlarm === '1'">
                {{ item.highAlarmValue }}/-
              </p>
              <p v-if="item.openHighAlarm === '1' && item.openLowAlarm === '0'">
                -/{{ item.lowAlarmValue }}
              </p>
              <p v-if="item.openHighAlarm === '0' && item.openLowAlarm === '0'">
                {{ item.highAlarmValue }}/{{ item.lowAlarmValue }}
              </p>
              <p>{{ formatTimeHM(item.creationTime) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  lastSevenDayData,
  getDay,
  formatDateDay,
  formatTimeHM,
  getRandomNum,
} from "@/utils/index";
import {
  gasData,
  gasDayStatistics,
  getWarningStatistics,
  getGasNetworking,
} from "@/public/api.js";
import { StatisticsData, generateAvgArrayForGasData } from "./gasData.js";
import { gasType } from "./getType.js";

// 引入路由实例
export default {
  name: "Gas",
  components: {},
  data() {
    return {
      formatTimeHM,
      timer: null,
      nun: 0,
      itemTunnelTypeNUm: "1",
      tunnelListData: [],
      TunnelsData: {},
      myChart_GasDay: null,
      myChart_GasHoury: [],
      activeIndex: 0,
      gasADataTable: [],
      gasNetworkingData: [],
      lastSevenDays: lastSevenDayData(), // 新增最近七天的日期数组
      gasDeviceData: [
        {
          lable: "传感器总数",
          value: 1,
          unit: "台",
        },
        {
          lable: "设备在线",
          value: 1,
          unit: "台",
        },
        {
          lable: "设备离线",
          value: 0,
          unit: "台",
        },
        {
          lable: "设备在线率",
          value: 100,
          unit: "%",
        },
      ],
      form: {
        itemId: "",
        date: getDay(), // 结束时间
        pageNum: 1, // 页码
        pageSize: 10, // 每页显示条数
      },
      hostName: window.location.hostname,
    };
  },
  computed: {},
  mounted() {
    let that = this;
    that.TunnelsData = JSON.parse(localStorage.getItem("updateLhTunnels"));
    that.form.itemId = that.TunnelsData.itemId;
    that.tunnelListData = JSON.parse(localStorage.getItem("tunnelListData"));

    let hostName = window.location.hostname;

    that.getgasDayStatistics();
    that.getGetWarningStatistics();

    if (
      hostName == "localhost" ||
      hostName == "127.0.0.1" ||
      hostName == "39.100.79.198" ||
      hostName == "sd.yongsixinxi.com"
    ) {
      this.timer = setInterval(() => {
        that.gasNetworkingData = [];
        gasType().forEach((item) => {
          that.gasNetworkingData.push({
            regional: item.regional,
            position: item.position,
            name: item.name,
            nameAlias: item.nameAlias,
            value: item.value,
            unit: item.unit,
            highAlarmValue: item.highAlarmValue,
            lowAlarmValue: item.lowAlarmValue,
            openAlarmValue: "0",
            openHighAlarm: "0",
            openLowAlarm: "0",
            alarmValue: item.alarmValue,
            maxValue: item.maxValue,
            minValue: item.minValue,
            tunnelId: item.tunnelId,
            tunnelNumber: item.tunnelNumber,
            creationTime: new Date(),
          });
        });
      }, 2000);
    } else {
      that.getGasNetworkings();
      this.timer = setInterval(() => {
        that.getList();
        that.getgasDayStatistics();
        that.getGetWarningStatistics();
      }, 2000);
    }

    // 初始化图表
    this.myChart_GasDay = echarts.init(document.getElementById("main_gasDay"));
    this.myChart_GasHoury = echarts.init(
      document.getElementById("main_gasHoury")
    );
    this.axisLineGasHoury();
    this.axisLineGasDay();
    // 监听窗口大小变化，自动调整图表
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    getGasNetworkings() {
      let that = this;
      getGasNetworking({ itemId: that.TunnelsData.itemId }).then((res) => {
        if (res.status == 200) {
          res.data.data.forEach((item) => {
            item.gasTypes.forEach((itemType) => {
              that.gasNetworkingData.push({
                regional: item.name,
                position: "掌子面",
                name: itemType.name,
                nameAlias: itemType.nameAlias,
                value: 0,
                unit: itemType.unitName,
                highAlarmValue: itemType.highAlarmValue,
                lowAlarmValue: itemType.lowAlarmValue,
                openAlarmValue: itemType.openAlarmValue,
                openHighAlarm: itemType.openHighAlarm,
                openLowAlarm: itemType.openLowAlarm,
                alarmValue: itemType.alarmValue,
                maxValue: itemType.maxValue,
                minValue: itemType.minValue,
                tunnelId: item.id,
                tunnelNumber: item.tunnelNumber,
                creationTime: "",
              });
            });
          });
          that.getList();
        }
      });
    },
    getList() {
      let that = this;
      gasData({ itemId: that.TunnelsData.itemId }).then((res) => {
        if (res.status == 200) {
          that.gasNetworkingData.forEach((gasItem) => {
            res.data.data.forEach((item) => {
              if (item.name == gasItem.name) {
                gasItem.value = item.value;
                gasItem.creationTime = item.creationTime;
              }
            });
          });
        } else {
          console.error(res.message);
        }
      });
    },
    getgasDayStatistics() {
      let that = this;
      gasDayStatistics({ itemId: that.TunnelsData.itemId }).then((res) => {
        if (res.status == 200) {
          let legendData = [];
          let seriesData = [];
          let data = [];

          if (
            that.hostName == "127.0.0.1" ||
            that.hostName == "39.100.79.198" ||
            that.hostName == "sd.yongsixinxi.com"
          ) {
            data = generateAvgArrayForGasData();
          } else {
            data = res.data.data;
          }

          data.forEach((item) => {
            legendData.push(item.gasName);
            seriesData.push({
              name: item.gasName,
              type: "line",
              stack: "总量",
              data: item.avgArray,
              // lineStyle: {
              // 	color: item.color // 深蓝色
              // },
              // itemStyle: {
              // 	color: item.color // 气体图例标记颜色
              // }
            });
          });
          that.axisLineGasHoury(legendData, seriesData);
        } else {
          console.error(res.message);
        }
      });
    },
    getGetWarningStatistics() {
      let that = this;
      getWarningStatistics({ itemId: that.TunnelsData.itemId }).then((res) => {
        if (res.status == 200) {
          const seriesList = [];
          if (
            that.hostName == "127.0.0.1" ||
            that.hostName == "39.100.79.198" ||
            that.hostName == "sd.yongsixinxi.com"
          ) {
            StatisticsData().forEach((item) => {
              seriesList.push(item.value);
            });
          } else {
            for (const [key, value] of Object.entries(res.data.data.gas)) {
              seriesList.push(value);
            }
          }

          that.axisLineGasDay(seriesList);
        } else {
          console.error(res.message);
        }
      });
    },
    axisLineGasDay(seriesList) {
      let data = [];
      this.lastSevenDays.forEach((item) => {
        data.push(item.date);
      });

      let option = {
        tooltip: {
          trigger: "axis",
          appendToBody: true, // 👈 添加这一行
          textStyle: {
            color: "#666",
            fontSize: "0.875rem",
          },
        },
        toolbox: {
          show: false,
        },
        calculable: true,
        legend: {
          show: false,
          data: ["预警", "总数"],
        },
        xAxis: [
          {
            type: "category",
            data: data,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
          },
          {
            type: "value",
            name: "",
          },
        ],
        series: [
          {
            name: "预警",
            type: "bar",
            data: seriesList,
          },
          {
            name: "总数",
            type: "line",
            data: seriesList,
          },
        ],
      };

      this.myChart_GasDay.setOption(option);
    },
    axisLineGasHoury(legendData, seriesData) {
      const xAxisData = [];
      for (let i = 1; i <= 24; i++) {
        xAxisData.push(i + ":00");
      }

      // 配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          appendToBody: true, // 👈 添加这一行
          textStyle: {
            color: "#666",
            fontSize: "0.875rem",
          },
        },
        legend: {
          data: legendData,
          textStyle: {
            color: "white",
            fontSize: "0.725rem",
          },
          icon: "rect", // 使用矩形标记
          itemHeight: 3, // 控制图例标记的高度（单位：px）
          itemWidth: 16, // 控制图例标记的宽度（单位：px），可选，保持与高度一致或按比例设置
          itemGap: 20, // 调整图例项之间的间距，避免拥挤
        },
        toolbox: {
          show: false,
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: xAxisData,
            axisLabel: {
              interval: 0, // 关键：0表示强制显示所有标签（原1可能会间隔显示）
              color: "white",
              rotate: 0, // 标签旋转30度，避免横向挤压
              margin: 15, // 增加标签与轴线的距离，防止重叠,
              fontSize: "0.675rem",
              align: "center", // 标签旋转后居中对齐
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            // 显示Y轴方向的竖线（网格线）
            splitLine: {
              show: true, // 开启竖线
              lineStyle: {
                color: "#f0f0f0",
                width: 0.4,
                type: "solid",
              },
            },
            // 可选：设置Y轴线本身的样式
            axisLine: {
              show: true,
              lineStyle: {
                color: "#ccc",
                width: 0.3,
                fontSize: "0755rem",
                type: "solid",
              },
            },
          },
        ],
        series: seriesData,
      };

      this.myChart_GasHoury.setOption(option);
    },
    handleTunnelClick(direction, num) {
      this.itemTunnelTypeNUm = num;
      this.nun = direction;
      this.nun = Math.max(0, Math.min(this.nun, this.tunnelData.length - 1));
    },
    // 窗口大小变化时调整图表
    handleResize() {
      if (this.myChart_GasDay) {
        this.myChart_GasDay.resize();
      }
      if (this.myChart_GasHoury) {
        this.myChart_GasHoury.resize();
      }
    },
  },
  beforeDestroy() {
    // 移除事件监听，销毁图表
    window.removeEventListener("resize", this.handleResize);
    if (this.myChart_GasDay) {
      this.myChart_GasDay.dispose();
    }
    if (this.myChart_GasHoury) {
      this.myChart_GasHoury.dispose();
    }
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>
<style scoped>
/* 引入字体 */
@font-face {
  font-family: "DS-Digital";
  src: url("../font/DS-DIGIB.TTF") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.cloud-Gas {
  position: relative;
  top: 5px;
  left: 1%;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* 新增：确保padding不撑大容器 */

  .cloud-Gas-l {
    width: 48%;
    height: 100%;
    float: left;
  }

  .cloud-Gas-r {
    width: 49.5%;
    height: 100%;
    float: left;
    margin-left: 0.6vw;
  }

  .cloud-Gas-title {
    position: relative;
    margin-top: 1vh;
    left: 0;
    width: 100%;
    height: calc(445 / 1080 * 100vh);
    background: rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    overflow: hidden;
    /* 新增：禁止子元素超出父容器 */
    box-sizing: border-box;
    /* 新增：确保padding不撑大容器 */

    > .cloud-Gas-title-title {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;

      img {
        width: 100%;
        height: auto;
        margin: 0;
        padding: 0;
        overflow: hidden;
        /* 新增：禁止子元素超出父容器 */
        box-sizing: border-box;
        /* 新增：确保padding不撑大容器 */
      }

      p {
        position: absolute;
        top: 0.3vh;
        left: 3.01vh;
        width: 100%;
        height: 3vh;
        line-height: 3vh;
        margin: 0;
        padding: 0;
        font-size: 1rem;
        color: #fff;
        text-align: left;
        white-space: nowrap;
        /* 关键：禁止文本换行 */
        text-overflow: ellipsis;
        /* 关键：超出部分显示省略号 */
        overflow: hidden;
        /* 关键：配合text-overflow生效 */
        max-width: calc(100% - 4vh);
        /* 新增：限制文本最大宽度，避免超出父容器 */
      }
    }

    .cloud-Gas-title-content {
      position: relative;
      top: 0px;
      left: 0px;
      width: 93%;
      height: calc(385 / 1080 * 100vh);
      margin: 0;
      padding: 10px;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
      overflow-y: auto;
      /* 保留纵向滚动，禁止横向滚动 */
      overflow-x: hidden;
      /* 关键：禁止横向内容跳出 */
      scrollbar-width: thin;
      scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
      box-sizing: border-box;
      /* 确保padding不撑大宽度 */
    }
  }

  ::v-deep .el-progress__text {
    font-size: 0.8rem !important;
    margin-left: 20px !important;
    color: #fff;
  }

  /* 图表容器样式 */
  .chart-container {
    width: 100%;
    height: 100%;
    /* 设置最小高度，避免过小 */
    box-sizing: border-box;
    padding: 5px;
    /* 增加内边距，避免内容贴边 */
  }

  .cloud-Gas-title-content-ul {
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 2vh;

    > li {
      width: 14vh;
      height: 7.5vh;
      margin: 0;
      padding: 0;
      float: left;
      margin-left: 6%;
      margin-top: 2vh;
      color: #dfef05;

      > div:nth-child(1) {
        width: 100%;
        height: 3.5vh;
        margin: 0;
        padding: 0;
        line-height: 2.5vh;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 0.9rem;
        font-style: normal;
        text-transform: none;
        color: #dfef05;
        background-image: url("@/assets/images/bj_kuangs.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-left: 0.5vw;

        > span {
          font-family: DS-Digital, DS-Digital;
          font-weight: 400;
          font-size: 2.2rem !important;
          color: #dfef05;
          font-style: normal;
          text-transform: none;
          margin-right: 0.3vw;
        }
      }

      > div:nth-child(2) {
        width: 100%;
        height: 3vh;
        margin: 0;
        padding: 0;
        line-height: 3vh;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 0.8rem;
        color: #999;
        font-style: normal;
        text-transform: none;

        > img {
          width: 15px;
          height: 15px !important;
          margin-right: 0.2vw;
          margin-top: 0.5vh;
          filter: brightness(1) drop-shadow(0 0 0 #fff);
        }
      }
    }
  }

  .cloud-Gas-title-content-table {
    width: 100%;
    height: 2.5vh;
    margin: 0;
    padding: 0;
    margin-top: 1vh;

    > p {
      height: 2.5vh;
      margin: 0;
      padding: 0;
      float: left;
      line-height: 2.5vh;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 0.9rem;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    > p:nth-child(1) {
      width: 18%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > p:nth-child(2) {
      width: 13%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > p:nth-child(3) {
      width: 15%;
    }

    > p:nth-child(4) {
      width: 10%;
    }

    > p:nth-child(5) {
      width: 10%;
    }

    > p:nth-child(6) {
      width: 18%;
    }

    > p:nth-child(7) {
      width: 10%;
    }
  }

  .cloud-Gas-title-title-ul-day {
    list-style: none;
    margin: 0;
    padding: 0;
    float: right;
    width: 22vw;
    height: 3vh;
    position: relative;
    margin-top: -3.8vh;
    background-color: #16386e;
    margin-right: 1vh;

    > li {
      width: 3vw;
      height: 3vh;
      margin: 0;
      padding: 0;
      line-height: 3vh;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 1.2rem;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      font-style: normal;
      text-transform: none;
      float: left;
      cursor: pointer;
      /* 鼠标悬浮显示指针，提示可点击 */

      > .dayDiv {
        height: 3vh;
        width: 100%;
        line-height: 3vh;
        margin: 0;
        padding: 0;
        font-size: 0.8rem;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  /* 选中状态样式 */
  .cloud-Gas-title-title-ul-day li.active .dayDiv {
    background-color: #409eff;
    /* 示例蓝色，可替换为需要的颜色 */
    color: #fff;
    /* 选中时文字变白，提高对比度 */
    border-radius: 4px;
  }

  .cloud-detail-title-btn {
    position: absolute;
    top: -1vh;
    left: 14.01vh;
    width: 230px;
    height: 2.5vh;
    list-style: none;

    > li {
      width: 35px;
      height: 2.5vh;
      margin: 0;
      padding: 0;
      font-size: 0.8rem;
      color: #adcc25;
      text-align: left;
      float: left;
      cursor: pointer;
      margin-right: 5px;
    }

    > .active {
      color: #e9f1eb;
    }
  }
}
</style>